export function debounced(ms: number) {
  let timerId: ReturnType<typeof setTimeout>;

  return function (target: unknown, propertyKey: string, descriptor: PropertyDescriptor) {
    const original = descriptor.value;

    descriptor.value = function debounce(...args: unknown[]) {
      clearTimeout(timerId);

      timerId = setTimeout(() => {
        original.apply(this, args);
      }, ms);

      if (debounce.hasOwnProperty('timer')) {
        descriptor.value.timer = timerId;
      } else {
        Object.defineProperty(debounce, 'timer', {
          value: timerId,
          writable: true,
        });
      }
    };

    return descriptor;
  };
}

export function cancelDebounce(fn: unknown) {
  if (fn && typeof fn === 'function' && 'timer' in fn && typeof fn.timer === 'number') {
    clearTimeout(fn.timer);
  }
}
